import axios from 'axios';
import { getLang } from '@/i18n/helpers';

// Create axios instance with default config
const api = axios.create({
  baseURL: import.meta.env.VITE_API_ENDPOINT || '/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // This ensures cookies are sent with requests
  xsrfCookieName: 'csrf_token', // If your server uses CSRF protection
  xsrfHeaderName: 'X-CSRF-Token'
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle unauthorized access
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle unauthorized access
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      // Only redirect if we're not already on an auth page to prevent loops
      const currentPath = window.location.pathname;
      const isAuthPage = /^\/((en|fr)\/(login|register|recovery|verification|errors)|auth(\/(login|register|recovery|verification|errors))?)$/.test(currentPath);
      if (!isAuthPage) {
        const locale = getLang(navigator.language);
        window.location.href = `/${locale}/login`;
      }
    }
    // If no response (network error) or 5xx error, redirect to /down
    if (!error.response || (error.response.status >= 500 && error.response.status < 600)) {
      if (window.location.pathname !== '/down') {
        window.location.href = '/down';
      }
    }
    return Promise.reject(error);
  }
);

export { api };
